export default "__VITE_ASSET__XI3VI9ll__"